import Image from 'next/image'
import Link from 'next/link'

export const ProductInfoPolicy = ({ gender }: { gender: string }) => {
  console.log('gender', gender)
  //nếu là đồ nam thì 60 ngày đổi trả vì bất ký lý do gì
  //nếu là đồ nữ thì 60 ngày đổi trả (sản phẩm chưa qua sử dụng và còn nguyên nhãn mác)

  const infosFemale = [
    {
      icon: '/image/May2025/mceclip1_69.png',
      title: (
        <>
          Đổi trả cực dễ chỉ cần <br /> số điện thoại
        </>
      ),
    },
    {
      icon: '/icons/product/return-60.svg',
      title:
        '60 ngày đổi trả (sản phẩm chưa qua sử dụng và còn nguyên nhãn mác)',
    },
    {
      icon: '/icons/product/phone.svg',
      title: (
        <>
          Hotline 1900.27.27.37 <br /> hỗ trợ từ 8h30 - 22h
        </>
      ),
    },
    {
      icon: '/icons/product/location.svg',
      title: (
        <>
          Đến tận nơi nhận hàng trả,
          <br /> hoàn tiền trong 24h
        </>
      ),
    },
  ]

  const infosMale = [
    {
      icon: '/icons/product/free-ship.svg',
      title: <>Free ship cho đơn từ 200k</>,
    },
    {
      icon: '/icons/product/return-60.svg',
      title: '60 ngày đổi trả vì bất ký lý do gì',
    },
    {
      icon: '/icons/product/phone.svg',
      title: (
        <>
          Hotline 1900.27.27.37 <br /> hỗ trợ từ 8h30 - 22h
        </>
      ),
    },
    {
      icon: '/icons/product/location.svg',
      title: (
        <>
          Đến tận nơi nhận hàng trả,
          <br /> hoàn tiền trong 24h
        </>
      ),
    },
  ]

  const infos = gender === 'MALE' ? infosMale : infosFemale

  return (
    <div
      className='text-center lg:!mt-2 lg:border-t lg:border-t-neutral-200 lg:pb-0 lg:pt-2'
      id='product-detail-policy'
    >
      <Link
        href={'#product-description'}
        className='mb-2 inline-block py-1.5 font-sans text-sm font-medium leading-4.5 text-neutral-700 underline lg:py-0 lg:pb-1 lg:text-base lg:leading-5'
      >
        Mô tả sản phẩm
      </Link>

      <ul className='grid grid-cols-2 gap-2 rounded-lg bg-neutral-100 p-2 lg:gap-8 lg:gap-y-4 lg:p-4'>
        {infos.map((item, index) => (
          <li key={index} className='flex items-center gap-2 lg:gap-3'>
            <Image
              src={item.icon}
              alt='product-info-suggest-1'
              width={28}
              height={28}
              className='rounded-lg lg:h-10.5 lg:w-10.5'
            />
            <p className='text-left text-xxs leading-3 text-neutral-900 lg:text-xs'>
              {item.title}
            </p>
          </li>
        ))}
      </ul>
    </div>
  )
}
